export default __webpack_public_path__ + "static/5-best-aussie-roadtrips-df599b41aa8eb1dc9711160154bbf5f7.jpg";